// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#pvf1[data-v-2df31cd5]{background-color:#1b2445;box-sizing:border-box}#pvf1[data-v-2df31cd5],#pvf1 .box[data-v-2df31cd5]{position:relative;width:100%;height:100%}#pvf1 element.style[data-v-2df31cd5]{width:100%}", ""]);
// Exports
module.exports = exports;
